import { useEffect } from 'react';

import { useFCM } from '@hooks/useFCM';
import { useAuth } from '@hooks/useAuth';

/**
 * FCM Initializer Component
 * Initializes Firebase Cloud Messaging and requests permission
 * Should be included in the root App component
 */
export function FCMInitializer(): JSX.Element | null {
  const { user } = useAuth();
  const { isSupported, requestPermission } = useFCM();

  useEffect(() => {
    if (user && isSupported) {
      // Request permission after user is logged in
      // Delay slightly to not interrupt initial page load
      const timer = setTimeout(() => {
        requestPermission();
      }, 2000);

      return () => {
        clearTimeout(timer);
      };
    }
    return undefined;
  }, [user, isSupported, requestPermission]);

  return null;
}

